// extracted by mini-css-extract-plugin
module.exports = {"defaultCol":"Table_defaultCol__3y8-_"};